import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import {
  uploadS3ZoomProgress,
  loadCoursesUserData,
  loadCoursesUserDataStart
} from '../../actions'

import { CSVLink, CSVDownload } from 'react-csv'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class CourseStudentsExportStepThree extends Component {
  constructor(props) {
    super(props)
    this.csvLinkEl = React.createRef()
  }

  componentDidMount() {
    const { data, getStudents } = this.props

    // loadCoursesUserData(data.courseId);

    getStudents({ courseId: data.courseId })
  }

  downloadReport = async (option = 'slow') => {
    if (option === 'quick') {
      this.csvLinkEl.current.link.click()
    } else {
      setTimeout(() => {
        this.csvLinkEl.current.link.click()
      }, 1000)
    }
  }

  render() {
    const { data, uploadRequest } = this.props

    console.log(data.users)

    let uploadingStatus = data.users.loading
    let textStatus = 'Fetching data please wait'

    if (uploadingStatus === false) {
      this.downloadReport()
    }

    return (
      <React.Fragment>
        <p>
          {uploadingStatus == true ? (
            <LinearProgress />
          ) : (
            <Alert severity='success'>
              <p style={{ margin: 0 }}>
                Student data successfully downloaded, If not please
                <span
                  onClick={() => {
                    this.downloadReport('quick')
                  }}
                  style={{
                    marginLeft: 5,
                    marginRight: 5,
                    cursor: 'pointer',
                    backgroundColor: '#015548',
                    color: '#fff',
                    padding: 2
                  }}
                >
                  Click Here{' '}
                </span>
              </p>
            </Alert>
          )}
        </p>
        <Grid container spacing={3}>
          {uploadingStatus == false ? (
            <div>
              <Button
                style={{
                  marginTop: '30px',
                  marginBottom: '30px'
                }}
                variant='outlined'
                size='large'
                color='primary'
                onClick={() => window.location.reload(false)}
              >
                Back to Home
              </Button>{' '}
            </div>
          ) : (
            <Button>
              Downloading.. csv export will download automatically. Don't close
              the browser.
            </Button>
          )}

          <CSVLink
            filename={`course-${data.courseId}-students-data.csv`}
            data={data.users.data}
            ref={this.csvLinkEl}
          />

          <div></div>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.CourseStudentExport
})
const mapDispatchToProps = (dispatch) => ({
  getStudents: (courseId) => {
    dispatch(loadCoursesUserData(courseId))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseStudentsExportStepThree)
